module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('p', {
    staticClass: "headline",
    staticStyle: {
      "margin-bottom": "50px"
    },
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n    Invite influencers for campaign:\n    "), _c('strong', [_vm._v(_vm._s(_vm.campaign.campaignName))])]), _vm._v(" "), _c('v-row', [_c('v-col', [_c('div', [_c('div', {
    staticClass: "client_deteial_title"
  }, [_vm._v("Client Details")]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "ma-0 subtitle-1"
  }, [_c('strong', [_vm._v("Client Name:")]), _vm._v(" " + _vm._s(_vm.client.clientName))]), _vm._v(" "), _c('p', {
    staticClass: "ma-0 subtitle-1"
  }, [_c('strong', [_vm._v("Email:")]), _vm._v(" " + _vm._s(_vm.client.clientEmail))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.client.clientPhoneNumber),
      expression: "client.clientPhoneNumber"
    }],
    staticClass: "ma-0 subtitle-1"
  }, [_c('strong', [_vm._v("Phone:")]), _vm._v(" " + _vm._s(_vm.client.clientPhoneNumber))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.client.clientWebsite),
      expression: "client.clientWebsite"
    }],
    staticClass: "ma-0 subtitle-1"
  }, [_c('strong', [_vm._v("Website:")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.client.clientWebsite
    }
  }, [_vm._v(_vm._s(_vm.client.clientWebsite))])])])])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#78909C",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Contents")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm.campaign.min_content) + " to " + _vm._s(_vm.campaign.max_content))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm.measurement.total))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Invited Total: " + _vm._s(_vm.measurement.invitedTotal))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Not Invited Total: " + _vm._s(_vm.measurement.notInvitedTotal))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.totalPercentage) + " %")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#00838F",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Outreach")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("thousandSeprator")(_vm.campaign.outreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.outreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Invited Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.invitedOutreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Not Invited Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.notInvitedOutreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.outreachPercentage) + "%")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#00C853",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Engagement")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("thousandSeprator")(_vm.campaign.engagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.engagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Invited Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.invitedEngagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Not Invited Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.notInvitedEngagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.engagementPercentage) + "%")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#0091EA",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Budget")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("currency")(_vm.budget)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("COGS: " + _vm._s(_vm._f("currency")(_vm.measurement.budget)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Invited COGS: " + _vm._s(_vm._f("currency")(_vm.measurement.invitedBudget)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Not Invited COGS: " + _vm._s(_vm._f("currency")(_vm.measurement.notInvitedBudget)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.cogsPercentage) + "%")])])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "success",
      "disabled": _vm.disableSaveEdit
    },
    on: {
      "click": _vm.saveEditingData
    }
  }, [_vm._v("Save Changes")]), _vm._v(" "), (!_vm.disableSaveEdit) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "warning"
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("Cancel")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.influencers,
      "sort-by": "calories",
      "show-select": "",
      "single-select": false
    },
    on: {
      "toggle-select-all": _vm.selectAllInfluencers
    },
    scopedSlots: _vm._u([{
      key: "top",
      fn: function() {
        return [_c('v-toolbar', {
          attrs: {
            "flat": "",
            "color": "white"
          }
        }, [_c('v-toolbar-title', [_vm._v("Influencers")]), _vm._v(" "), _c('v-divider', {
          staticClass: "mx-4",
          attrs: {
            "inset": "",
            "vertical": ""
          }
        }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-dialog', {
          attrs: {
            "max-width": "500px",
            "content-class": "ims-standard-dialog"
          },
          model: {
            value: (_vm.dialog),
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        }, [_c('v-card', {
          staticClass: "ims-modal-card"
        }, [_c('v-card-title', {
          staticClass: "edit-influencer-title"
        }, [_c('span', {
          staticClass: "headline"
        }, [_vm._v("Edit Influencer" + _vm._s(_vm.formTitle ? (" - " + _vm.formTitle) : ''))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
          attrs: {
            "icon": "",
            "color": "secondary",
            "aria-label": "Close",
            "title": "Close"
          },
          on: {
            "click": _vm.close
          }
        }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('v-row', [_c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "12",
            "md": "12"
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Email",
            "color": "secondary"
          },
          model: {
            value: (_vm.editedItem.email),
            callback: function($$v) {
              _vm.$set(_vm.editedItem, "email", $$v)
            },
            expression: "editedItem.email"
          }
        })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "6",
            "md": "4"
          }
        }, [_c('v-text-field', {
          attrs: {
            "type": "number",
            "min": "0",
            "label": "IG Post deliverables",
            "color": "secondary"
          },
          model: {
            value: (_vm.editedItem.no_of_posts),
            callback: function($$v) {
              _vm.$set(_vm.editedItem, "no_of_posts", $$v)
            },
            expression: "editedItem.no_of_posts"
          }
        })], 1), _vm._v(" "), _c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "6",
            "md": "4"
          }
        }, [_c('v-text-field', {
          attrs: {
            "type": "number",
            "min": "0",
            "label": "IG Carousel deliverables",
            "color": "secondary"
          },
          model: {
            value: (_vm.editedItem.no_of_carousels),
            callback: function($$v) {
              _vm.$set(_vm.editedItem, "no_of_carousels", $$v)
            },
            expression: "editedItem.no_of_carousels"
          }
        })], 1), _vm._v(" "), _c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "6",
            "md": "4"
          }
        }, [_c('v-text-field', {
          attrs: {
            "type": "number",
            "min": "0",
            "label": "IG Story deliverables",
            "color": "secondary"
          },
          model: {
            value: (_vm.editedItem.no_of_stories),
            callback: function($$v) {
              _vm.$set(_vm.editedItem, "no_of_stories", $$v)
            },
            expression: "editedItem.no_of_stories"
          }
        })], 1), _vm._v(" "), _c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "6",
            "md": "4"
          }
        }, [_c('v-text-field', {
          attrs: {
            "type": "number",
            "min": "0",
            "label": "IG Video deliverables",
            "color": "secondary"
          },
          model: {
            value: (_vm.editedItem.no_of_video),
            callback: function($$v) {
              _vm.$set(_vm.editedItem, "no_of_video", $$v)
            },
            expression: "editedItem.no_of_video"
          }
        })], 1), _vm._v(" "), _c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "6",
            "md": "4"
          }
        }, [_c('v-text-field', {
          attrs: {
            "type": "number",
            "min": "0",
            "label": "IG TV deliverables",
            "color": "secondary"
          },
          model: {
            value: (_vm.editedItem.no_of_igTv),
            callback: function($$v) {
              _vm.$set(_vm.editedItem, "no_of_igTv", $$v)
            },
            expression: "editedItem.no_of_igTv"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "secondary",
            "text": ""
          },
          on: {
            "click": _vm.close
          }
        }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "secondary",
            "text": ""
          },
          on: {
            "click": _vm.save
          }
        }, [_vm._v("Save")])], 1)], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [_c('tbody', _vm._l((items), function(item) {
          return _c('tr', {
            key: item.name
          }, [_c('td', [_c('v-checkbox', {
            attrs: {
              "value": item.id,
              "disabled": !_vm.isValidPairing(item)
            },
            model: {
              value: (_vm.selectedInfluencers),
              callback: function($$v) {
                _vm.selectedInfluencers = $$v
              },
              expression: "selectedInfluencers"
            }
          })], 1), _vm._v(" "), _c('td', [(item.platform === 'tiktok') ? _c('a', {
            attrs: {
              "href": 'https://www.tiktok.com/@' + item.instagramHandle,
              "target": "_blank"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/tiktok-32.png",
              "width": "20px"
            }
          }), _vm._v(" @" + _vm._s(item.instagramHandle))]) : _c('a', {
            attrs: {
              "target": "_blank",
              "href": 'https://instagram.com/' + item.instagramHandle
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(item.instagramHandle))], 1), _vm._v(" "), (!item.isLoading && item.influencerID) ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  attrs: {
                    "color": "green"
                  },
                  on: {
                    "click": true
                  }
                }, on), [_vm._v("done")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Registered on IMS")])]) : _vm._e(), _vm._v(" "), (!item.isLoading && !item.influencerID) ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  attrs: {
                    "color": "red"
                  },
                  on: {
                    "click": true
                  }
                }, on), [_vm._v("cancel")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Not in IMS")])]) : _vm._e()], 1), _vm._v(" "), _c('td', [(item.emailEdit === false) ? _c('div', {
            staticClass: "item-edit",
            on: {
              "click": function($event) {
                return _vm.openEditItem(item, 'email')
              }
            }
          }, [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "75px"
            }
          }, [_vm._v(_vm._s(item.email))])]) : _c('div', [_c('v-text-field', _vm._g({
            staticClass: "mt-3",
            staticStyle: {
              "width": "290px"
            },
            attrs: {
              "outlined": "",
              "color": "secondary"
            },
            model: {
              value: (item.email),
              callback: function($$v) {
                _vm.$set(item, "email", $$v)
              },
              expression: "item.email"
            }
          }, _vm.on))], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(item.payout)))]), _vm._v(" "), _c('td', [(item.no_of_posts) ? _c('p', {
            staticClass: "ma-0 body-2"
          }, [_c('span', [_vm._v(_vm._s(item.no_of_posts > 0 ? item.no_of_posts : '') + " " + _vm._s(item.no_of_posts > 0 ? item.no_of_posts > 1 ? 'Posts' : 'Post' : ''))])]) : _vm._e(), _vm._v(" "), (item.no_of_carousels) ? _c('p', {
            staticClass: "ma-0 body-2"
          }, [_c('span', [_vm._v(_vm._s(item.no_of_carousels > 0 ? item.no_of_carousels : '') + " " + _vm._s(item.no_of_carousels > 0 ? item.no_of_carousels > 1 ? 'Carousels' : 'Carousels' : ''))])]) : _vm._e(), _vm._v(" "), (item.no_of_stories) ? _c('p', {
            staticClass: "ma-0 body-2"
          }, [_c('span', [_vm._v(_vm._s(item.no_of_stories > 0 ? item.no_of_stories : '') + "  " + _vm._s(item.no_of_stories > 0 ? (item.no_of_stories > 1 ? 'Stories' : 'Story') : '') + " ")])]) : _vm._e(), _vm._v(" "), (item.no_of_video) ? _c('p', {
            staticClass: "ma-0 body-2"
          }, [_c('span', [_vm._v(_vm._s(item.no_of_video > 0 ? item.no_of_video : '') + " " + _vm._s(item.no_of_video > 0 ? item.no_of_video > 1 ? 'Videos' : 'Video' : ''))])]) : _vm._e(), _vm._v(" "), (item.no_of_igTv) ? _c('p', {
            staticClass: "ma-0 body-2"
          }, [_c('span', [_vm._v(_vm._s(item.no_of_igTv > 0 ? item.no_of_igTv : '') + " " + _vm._s(item.no_of_igTv > 0 ? item.no_of_igTv > 1 ? 'TVs' : 'TV' : ''))])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('pairing-status', {
            attrs: {
              "status": item.pairingStatus
            }
          })], 1), _vm._v(" "), _c('td', [_c('v-btn', {
            attrs: {
              "fab": "",
              "small": "",
              "color": "secondary"
            },
            on: {
              "click": function($event) {
                return _vm.editItem(item)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-pencil")])], 1), _vm._v(" "), _c('v-btn', {
            attrs: {
              "fab": "",
              "small": "",
              "color": "secondary"
            },
            on: {
              "click": function($event) {
                return _vm.preview(item, _vm.selectedTemplate.templateHTML)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-file-find")])], 1)], 1)])
        }), 0)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.emailDialog = true
      }
    }
  }, [_vm._v("          \n        Invite with Email\n        "), _c('v-icon', {
    attrs: {
      "dark": "",
      "right": ""
    }
  }, [_vm._v("\n          mdi-email-plus\n        ")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "warning",
      "disabled": !_vm.selectedInfluencers || _vm.selectedInfluencers.length === 0
    },
    on: {
      "click": function($event) {
        return _vm.updateInvitedStatus(_vm.selectedInfluencers)
      }
    }
  }, [_vm._v("Invite (" + _vm._s(_vm.selectedInfluencers.length) + ")")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "700",
      "persistent": ""
    },
    model: {
      value: (_vm.emailDialog),
      callback: function($$v) {
        _vm.emailDialog = $$v
      },
      expression: "emailDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n        Email template creation\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.emailDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-autocomplete', {
    staticClass: "mb-2",
    attrs: {
      "items": _vm.templates,
      "item-text": "name",
      "hide-details": "",
      "dense": "",
      "filled": "",
      "return-object": "",
      "label": "Select Template"
    },
    model: {
      value: (_vm.selectedTemplate),
      callback: function($$v) {
        _vm.selectedTemplate = $$v
      },
      expression: "selectedTemplate"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "mb-2",
    attrs: {
      "items": _vm.fromEmail,
      "item-text": "name",
      "hide-details": "",
      "dense": "",
      "filled": "",
      "return-object": "",
      "label": "From:"
    },
    model: {
      value: (_vm.selectedFromEmail),
      callback: function($$v) {
        _vm.selectedFromEmail = $$v
      },
      expression: "selectedFromEmail"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticStyle: {
      "margin": "10px 0px 10px 0px"
    },
    attrs: {
      "lass": "mb-2",
      "hide-details": "",
      "label": "Subject",
      "single-line": "",
      "filled": ""
    },
    model: {
      value: (_vm.selectedTemplate.subject),
      callback: function($$v) {
        _vm.$set(_vm.selectedTemplate, "subject", $$v)
      },
      expression: "selectedTemplate.subject"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticStyle: {
      "margin": "10px 0px 10px 0px"
    },
    attrs: {
      "lass": "mb-2",
      "label": "Campaign Invite URL",
      "filled": "",
      "readonly": ""
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      }
    },
    model: {
      value: (_vm.inviteUrl),
      callback: function($$v) {
        _vm.inviteUrl = $$v
      },
      expression: "inviteUrl"
    }
  }), _vm._v(" "), _c('vue-editor', {
    model: {
      value: (_vm.selectedTemplate.templateHTML),
      callback: function($$v) {
        _vm.$set(_vm.selectedTemplate, "templateHTML", $$v)
      },
      expression: "selectedTemplate.templateHTML"
    }
  }), _vm._v(" "), (_vm.keywords && _vm.keywords.length > 0) ? _c('p', {
    staticClass: "title"
  }, [_vm._v("Map values")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.keywords), function(keyword) {
    return _c('v-row', {
      key: keyword,
      attrs: {
        "align": "center",
        "justify": "center"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "5",
        "align": "end",
        "justify": "end"
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "Source",
        "filled": "",
        "disabled": "",
        "hide-details": "",
        "value": keyword
      }
    })], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "2",
        "align": "center",
        "justify": "center"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "primary"
      }
    }, [_vm._v("mdi-arrow-left-right")])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "5",
        "align": "center",
        "justify": "center"
      }
    }, [_c('v-autocomplete', {
      staticClass: "mb-2",
      attrs: {
        "items": _vm.fields,
        "hide-details": "",
        "value": _vm.keywordsMap.get(keyword),
        "dense": "",
        "filled": "",
        "label": "Target"
      },
      on: {
        "change": function($event) {
          return _vm.mapValue($event, keyword)
        }
      }
    })], 1)], 1)
  }), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('v-col', [_c('v-btn', {
    attrs: {
      "text": "",
      "disabled": !_vm.selectedTemplate._id
    },
    on: {
      "click": function($event) {
        return _vm.saveTemplateChanges(_vm.selectedTemplate._id)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.saveNewTemplate
    }
  }, [_vm._v("Save As")])], 1)], 1)], 2), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "secondary",
      "disabled": !_vm.selectedInfluencers || _vm.selectedInfluencers.length === 0
    },
    on: {
      "click": function($event) {
        return _vm.sendBulkInvitation(_vm.selectedInfluencers, _vm.selectedTemplate._id)
      }
    }
  }, [_vm._v("Send invite (" + _vm._s(_vm.selectedInfluencers.length) + ")")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "id": "sweetAlertContainer"
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "600px"
    },
    model: {
      value: (_vm.previewDialog),
      callback: function($$v) {
        _vm.previewDialog = $$v
      },
      expression: "previewDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Preview content")])]), _vm._v(" "), _c('v-card-text', {
    domProps: {
      "innerHTML": _vm._s(_vm.previewText)
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.previewDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('k-toast', {
    attrs: {
      "variant": _vm.toast.variant,
      "header": _vm.toast.header,
      "content": _vm.toast.content
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "400px"
    },
    model: {
      value: (_vm.sendingInvitationDialog),
      callback: function($$v) {
        _vm.sendingInvitationDialog = $$v
      },
      expression: "sendingInvitationDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [(_vm.isSending) ? _c('span', {
    staticClass: "headline"
  }, [_vm._v("In progress...")]) : _vm._e(), _vm._v(" "), (!_vm.isSending) ? _c('span', {
    staticClass: "headline"
  }, [_vm._v("Finished")]) : _vm._e()]), _vm._v(" "), _c('v-card-text', [(_vm.isSending) ? _c('v-progress-linear', {
    attrs: {
      "height": "15",
      "indeterminate": "",
      "color": "yellow darken-2"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-list', {
    attrs: {
      "disabled": ""
    }
  }, [_c('v-list-item-group', {
    attrs: {
      "color": "primary"
    }
  }, _vm._l((_vm.sendings), function(item, i) {
    return _c('v-list-item', {
      key: i
    }, [_c('v-list-item-icon', [(item.isSuccess) ? _c('v-icon', {
      attrs: {
        "color": "success"
      }
    }, [_vm._v("mdi-check")]) : _vm._e(), _vm._v(" "), (!item.isSuccess) ? _c('v-icon', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v("mdi-cancel")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("@" + _vm._s(item.instagramHandle))])], 1)], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "disabled": _vm.isSending,
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.sendingInvitationDialog = false
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b50e593"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/CampaignInvite/CampaignInvite.vue
// module id = 2020
// module chunks = 0